module.exports = __webpack_public_path__ + "static/img/icons_partners_blue.019b170.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_partners_blue.svg
// module id = Wwfd
// module chunks = 1